import { i18nKeys } from '@/src/utils/i18n.utils';

/** Status keys shown above the separator in the daily summary */
export const PRIMARY_STATUSES: string[] = ['WAS_EVER_ASSIGNED', 'WASTED', 'RESTARTED'];

/** Status keys shown below the separator in the daily summary */
export const SECONDARY_STATUSES: string[] = ['COMPLETED', 'INVALID', 'TIMED_OUT', 'TERMINATED'];

/** Maps raw status keys to their i18n translation keys for display labels */
export const STATUS_LABEL_KEYS: Record<string, string> = {
  WAS_EVER_ASSIGNED: i18nKeys.labDashboard.calendar.statusLabels.WAS_EVER_ASSIGNED,
  WASTED: i18nKeys.labDashboard.calendar.statusLabels.WASTED,
  INVALID: i18nKeys.labDashboard.calendar.statusLabels.INVALID,
  RESTARTED: i18nKeys.labDashboard.calendar.statusLabels.RESTARTED,
  COMPLETED: i18nKeys.labDashboard.calendar.statusLabels.COMPLETED,
  TIMED_OUT: i18nKeys.labDashboard.calendar.statusLabels.TIMED_OUT,
  TERMINATED: i18nKeys.labDashboard.calendar.statusLabels.TERMINATED,
};

/** Maps raw status keys to their i18n translation keys for the status info popover */
export const STATUS_DESCRIPTION_KEYS: Record<string, string> = {
  WAS_EVER_ASSIGNED: i18nKeys.labDashboard.calendar.statusInfo.descriptions.WAS_EVER_ASSIGNED,
  WASTED: i18nKeys.labDashboard.calendar.statusInfo.descriptions.WASTED,
  INVALID: i18nKeys.labDashboard.calendar.statusInfo.descriptions.INVALID,
  RESTARTED: i18nKeys.labDashboard.calendar.statusInfo.descriptions.RESTARTED,
  COMPLETED: i18nKeys.labDashboard.calendar.statusInfo.descriptions.COMPLETED,
  TIMED_OUT: i18nKeys.labDashboard.calendar.statusInfo.descriptions.TIMED_OUT,
  TERMINATED: i18nKeys.labDashboard.calendar.statusInfo.descriptions.TERMINATED,
};
